import { render, staticRenderFns } from "./BindsDialogActions.vue?vue&type=template&id=0a6177d7&"
import script from "./BindsDialogActions.vue?vue&type=script&lang=js&"
export * from "./BindsDialogActions.vue?vue&type=script&lang=js&"
import style0 from "./BindsDialogActions.vue?vue&type=style&index=0&id=0a6177d7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports